import React,{Component} from 'react';
import {Toast} from "antd-mobile";
import {connect} from "react-redux";
import {cityCispatcher} from "../../../../service/cityService";
import "./index.less";
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class CityModule extends Component{
    constructor(props) {
        super(props);
        this.state = {
            waiting:0,
            working:0,
        }
    };
    componentDidMount() {
        let params={
            token: this.props.userInfo.token,
        };
       this._getOrderList(params);
    }
    _getOrderList(params){
        cityCispatcher(params).then((res) => {
                if(res.data.code == "0000"){
                  this.setState({
                      waiting:res.data.data.waiting,
                      working:res.data.data.working
                  })
                }else {
                    Toast.info(res.data.msg,3)
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
    goDispatch = (n) =>{
        if(n === 'waiting'){
            this.props.goPage('CityDispatcher')
        }
        else if(n === 'working'){
            this.props.goPage('CityWorking')
        }
    }
    render() {
        return (
            <div className="cityModule">
                <div className="cardBox">
                    <div>{this.state.working}</div>
                    <div>当前进行中订单</div>
                    <div className="blue" onClick={()=>this.goDispatch("working")}>查看订单</div>
                </div>
                <div className="cardBox">
                    <div>{this.state.waiting}</div>
                    <div>当前待指派订单</div>
                    <div className="orange" onClick={()=>this.goDispatch("waiting")}>派单调度</div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/changeRole/City/index.js